export default __webpack_public_path__ + "static/media/person.8a9a97fd.png";